import type { CheckboxProps } from '@vgn-medien-holding/vgn-fe-components';

// Mirrors autorevue's heavily-tuned checkout checkbox (white box, brand-red
// border and check, mt tweaks for vertical alignment with the label).
const classProps = {
  root: '',
  checkboxWrapper: 'mt-px flex-none',
  checkbox: 'w-full h-full bg-white border border-tvmedia checked:border-tvmedia',
  checkmark: 'text-tvmedia',
  label: 'ml-2 cursor-pointer text-sm',
  errorMessage: 'mt-1 text-tvmedia text-xs',
} as CheckboxProps['classProps'];

export default classProps;
